import api from './apiService';
import Project from '../../common/Utils/project';

export enum PolicyMode {
  Blacklist = 'Blacklist',
  Allowlist = 'Allowlist',
  Partial = 'Partial',
}

export interface SoftwarePolicy {
  softwareName: string;
  packageIdentifier: string;
  policyMode: PolicyMode;
  groupIdList?: string[];
  groups?: string[];
  blockedVersions: string[];
}

export interface SubmitPolicyItem {
  packageIdentifier: string;
  softwareName: string;
  policyMode: PolicyMode;
  groupIdList: string[];
  updatedBy: string;
  blockedVersions?: string[];
}

/**
 * Checks policy status for a list of software names.
 * To check a single software, pass a single-item array.
 */
export const checkSoftwarePolicies = async (tenantId: string, softwareNames: string[]): Promise<SoftwarePolicy[]> => {
  const response = await api.post(`${Project.api}assetmgtservice/TenantSoftwareCompliance/${tenantId}/check-software-policies`, {
    softwareNames,
  });
  const { data } = response;
  if (data?.isSuccess && Array.isArray(data?.data)) {
    return data.data as SoftwarePolicy[];
  }
  return [];
};

/**
 * Submits software policies for a list of items.
 * To set policy for a single software, pass a single-item array.
 */
export const submitSoftwarePolicies = async (
  tenantId: string,
  payload: SubmitPolicyItem[],
): Promise<{ isSuccess: boolean; message?: string }> => {
  const response = await api.post(`${Project.api}assetmgtservice/TenantSoftwareCompliance/${tenantId}/software-policies`, payload);
  return response?.data ?? { isSuccess: false };
};
